module.exports = __webpack_public_path__ + "img/yaourtrouge_on.74ecbf2e.gif";